import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveMembersWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-active-members-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card">
      <span class="stat-card__label">Active members</span>
      <ng-container *ngIf="data as widget; else noData">
        <span class="stat-card__value">{{ widget.count | number }}</span>
        <span class="stat-card__detail">
          {{ widget.change > 0 ? '+' : '' }}{{ widget.change | number }} this period ·
          <span class="stat-card__highlight">{{ widget.percentOfCardCustomers | number : '1.0-1' }}%</span>
          of card customers
        </span>
      </ng-container>
      <ng-template #noData>
        <p class="stat-card__empty">No data available.</p>
      </ng-template>
    </div>
  `,
  styleUrl: '../stat-card.scss',
})
export class ActiveMembersWidgetComponent {
  @Input() data: ActiveMembersWidget | null = null;
}
